import React from "react";
import { Crosshair, ShieldCheck, TrendingUp, Truck } from "lucide-react";

const props = [
  { icon: Crosshair, title: "Precision-Built", text: "Every joint system engineered to exact movement tolerances and project specifications." },
  { icon: ShieldCheck, title: "Durability", text: "Heavy-duty steel, aluminum, and elastomeric components rated for demanding conditions." },
  { icon: TrendingUp, title: "Long-Term Performance", text: "Systems designed for decades of thermal, seismic, and traffic-induced movement." },
  { icon: Truck, title: "Philippine-Wide Supply", text: "Nationwide delivery and technical support for projects from Luzon to Mindanao." },
];

export default function ValueProps() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {props.map((p) => (
          <div key={p.title} className="group border border-gray-200 p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#E4001C]/40">
            <div className="w-12 h-12 flex items-center justify-center bg-[#0A0A0A] group-hover:bg-[#E4001C] transition-colors mb-6">
              <p.icon className="w-6 h-6 text-white" />
            </div>
            <h2 className="font-tech font-semibold uppercase tracking-widest text-lg mb-3">{p.title}</h2>
            <p className="text-sm text-[#171717]/70 leading-relaxed">{p.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}